// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b5b36eb6","885":"d2651f30"}[chunkId] + ".chunk.js";
};